import { INVENTORY_QUERY_FRAGMENT } from '../../../../common/inventory/services/InventoryService';
import { BaseGQLService } from '../../../../common/services/BaseGQLService';
import { ModelType } from '../../../../common/utils/GQLIdEncoder';
import { ProjectExportOptions } from '../../../options/ProjectExportOptions';
import { ProjectPrintMapper } from '../mappers/ProjectPrintMapper';
import { ProjectPrintData } from '../models/ProjectPrintData';

export const GET_PROJECT_PRINT_QUERY = `
query ($projectId: ID!, $withExceptions: Boolean!) {
  project: node(id: $projectId) {
    ... on Project {
      name
      description
      lastAnalysis
      defaultProfile {
        id
        name
        type
      }
      organization {
        name
      }
      vulnerabilities(withExceptions: $withExceptions) {
        edges {
          node {
            number
            title
            shortExplanation
            severity
            numberOfSlots
          }
        }
      }
      inventory {
        ${INVENTORY_QUERY_FRAGMENT}
      }
    }
  }
}
`;

export class ProjectPrintRepository extends BaseGQLService {
  private readonly mapper = new ProjectPrintMapper();

  protected addTypename(): boolean {
    return false;
  }

  async getProject(projectId: number, options: ProjectExportOptions): Promise<ProjectPrintData> {
    const { withExceptions = false } = options;
    return this.query(
      GET_PROJECT_PRINT_QUERY,
      {
        projectId: this.gqlIdEncoder.encode(ModelType.Project, projectId),
        withExceptions,
      },
      (data) => this.mapper.mapGQLModel(data.project)
    );
  }
}
